import React from 'react'
import PropTypes from 'prop-types'

import { sanitizeDom } from '../../../utils'
import { useStyles } from './payment-price-change-alert.styles'
import { priceChangeAlertMessage } from '../subscription-constants'

/**
 * temp price change alert msg displayed on payment modal.
 * only displayed when user's paying for the plan that will increase price.
 */
const PaymentPriceChangeAlert = ({ isAnnuallyPlan, isStandardPlan }) => {
  const styles = useStyles()
  let message = ''
  if (isAnnuallyPlan) {
    message = priceChangeAlertMessage.annual
  } else if (isStandardPlan) {
    message = priceChangeAlertMessage.standard
  } else {
    message = priceChangeAlertMessage.basic
  }
  if (!message) return null

  return (
    <div
      className={styles.priceChangeAlertContainer}
      dangerouslySetInnerHTML={{ __html: sanitizeDom(message) }}
    />
  )
}

PaymentPriceChangeAlert.propTypes = {
  isAnnuallyPlan: PropTypes.bool.isRequired,
  isStandardPlan: PropTypes.bool.isRequired
}

export default PaymentPriceChangeAlert
